module.exports = function isString(x) {
  return typeof x === 'string';
};


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/isString.js
// module id = 151
// module chunks = 0